import {
  ActionReducerMapBuilder,
  createAsyncThunk,
  createSlice,
  PayloadAction,
  SerializedError,
} from '@reduxjs/toolkit'
import { esp } from '../lang/esp'
import { eng } from '../lang/eng'
import { sliderImagesApi } from '../api/api'
import { SliderImages } from '../types/sliderImages'
// import {
//   CalendarMain,
//   CreateMain,
//   Main,
//   UpcomingMains,
// } from '../types/main'
// import { loadMains, modifyMain, removeMain, saveMain } from '../api/main'
// import { findCurrentTimePeriodMains } from '../utils/findCurrentTimePeriodMains'
// import { isWithinInterval } from 'date-fns'
// import { findMainsByDate } from '../utils/findMainsByDate'

// get all getMainSliderImages
export const getMainSliderImages = createAsyncThunk(
  'main/getMainSliderImages',
  async (_, thunkApi) => {
    try {
      return await sliderImagesApi.getMainSliderImages()
    } catch (e) {
      return thunkApi.rejectWithValue('getMainSliderImages')
    }
  },
)

// // add main
// export const addMain = createAsyncThunk(
//   'main/addMain',
//   async (main: CreateMain, thunkApi) => {
//     try {
//       return await saveMain(main)
//     } catch (e) {
//       return thunkApi.rejectWithValue('addMainError')
//     }
//   },
// )

// // update main
// export const updateMain = createAsyncThunk(
//   'main/updateMain',
//   async (main: Main, thunkApi) => {
//     try {
//       return await modifyMain(main)
//     } catch (e) {
//       return thunkApi.rejectWithValue('updateMainError')
//     }
//   },
// )

// // delete objective
// export const deleteMain = createAsyncThunk(
//   'main/deleteMain',
//   async (id: string, thunkApi) => {
//     try {
//       return await removeMain(id)
//     } catch (e) {
//       return thunkApi.rejectWithValue('deleteMainError')
//     }
//   },
// )

interface MainSliceState {
  count: number
  language: string
  mainSliderImages: SliderImages[]
  mainSliderImagesUrl: string[]
  oneLineItemsCount: number
  price: 0
  words: object
  loading: boolean
  mainSliderImagesLoaded: boolean
  error?: SerializedError
}

const initialState: MainSliceState = {
  count: 0,
  language: '',
  mainSliderImages: [],
  mainSliderImagesUrl: [],
  oneLineItemsCount: 4,
  words: esp,
  price: 0,
  loading: false,
  mainSliderImagesLoaded: false,
  error: undefined,
}

const mainSlice = createSlice({
  name: 'main',
  initialState,
  reducers: {
    setLanguage: (state: MainSliceState, action: PayloadAction<string>) => {
      state.language = action.payload
      if (action.payload === 'esp') {
        state.words = esp
      } else if (action.payload === 'eng') {
        state.words = eng
      }
    },
  },
  extraReducers: (builder: ActionReducerMapBuilder<any>) => {
    builder.addCase(
      getMainSliderImages.fulfilled,
      (state: MainSliceState, action: any) => {
        state.mainSliderImages = action.payload
        state.mainSliderImagesUrl = action.payload?.map(
          (sliderImage: SliderImages) => sliderImage.image,
        )
        state.mainSliderImagesLoaded = true
        state.error = undefined
      },
    )

    builder.addCase(getMainSliderImages.pending, (state, action) => {
      state.mainSliderImagesLoaded = true
      state.error = undefined
    })

    builder.addCase(getMainSliderImages.rejected, (state, action) => {
      state.mainSliderImagesLoaded = true
      state.error = action.payload
    })
  },
})

export const { setLanguage } = mainSlice.actions
export default mainSlice
